module.exports = __webpack_public_path__ + "img/flag_152.17fc1091.png";